<template>
  <v-layout
    align-center
    wrap
  >
    <v-flex
      v-if="$apollo.queries.userBalance.loading"
      mt-10
      mb-10
      text-center
    >
      <v-progress-circular
        :size="40"
        color="primary"
        class="mb-2"
        indeterminate
      /><br>
      <b>{{ $t('gateway.almostDone') }}</b>
    </v-flex>

    <v-flex
      v-if="!$apollo.queries.userBalance.loading && gateway == null && enoughBalanceFunds && invoice.tag !== 'deposit_funds'"
      :class="invoiceId != 0 ? 'xs12' : 'xs5'"
    >
      <h2>{{ $t('gateway.orderConfirmation') }}!!!</h2>
      {{ $t('gateway.from_balance', {amount: $options.filters.renderSymbol(balance.currency)+invoice.total}) }}
      <center>
        <v-btn
          class="primary mt-15 mb-5"
          block
          :loading="loading"
          :disabled="loading"
          @click="payFromBalance()"
        >
          {{ $t('gateway.pay') }} {{ invoice.currency | renderSymbol }}{{ invoice.total }}
        </v-btn>
      </center>
    </v-flex>
    <v-flex
      v-else-if="!$apollo.loading && gateway == null && (!enoughBalanceFunds || invoice.tag === 'deposit_funds')"
      :class="invoiceId != 0 ? 'xs12' : 'xs5'"
    >
      <div
        v-if="invoice"
        class="gateway-card"
      >
        <center v-if="invoice.tag !== 'deposit_funds'">
          <span>
            {{ $t('gateway.insufficientFunds', {balance: $options.filters.renderSymbol(balance.currency)+balance.credit, total: $options.filters.renderSymbol(invoice.currency)+invoice.total}) }}
          </span>
          <h4
            class="mt-5 mb-5"
          >
            {{ $t('gateway.refill') }} {{ invoice.currency | renderSymbol }}{{ invoiceDiff }}
          </h4>
        </center>
        <center v-else>
          <h4
            class="mt-5 mb-5"
          >
            {{ $t('gateway.refillDeposit') }} {{ invoice.currency | renderSymbol }}{{ invoice.total }}
          </h4>
        </center>
        <v-layout
          wrap
          mt-5
          mb-5
        >
          <v-flex
            xs12
          >
            <v-card
              class="method"
              :ripple="false"
            >
              <center>
                <div class="crypto">
                  <v-img
                    :src="require('@/images/crypto/btc.svg')"
                    alt="cc"
                    max-width="50"
                    contain
                  />
                  <v-img
                    :src="require('@/images/crypto/eth.svg')"
                    alt="cc"
                    max-width="50"
                    contain
                  />
                  <v-img
                    :src="require('@/images/crypto/usdt.svg')"
                    alt="cc"
                    max-width="50"
                    contain
                  />
                </div>
              </center>
            </v-card>
          </v-flex>
          <v-flex
            ml-5
            mb-2
            xs12
          >
            <v-select
              v-model.trim="selectedCurrency"
              class="mt-3"
              :items="cpayConfig"
              :item-text="'name'"
              :item-value="'id'"
              name="currency"
            >
              <template
                slot="label"
              >
                <b>{{ $t('withdrawals.selectCurrency') }}</b>
              </template>
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  <small class="text-neutral">{{ data.item.description }}</small>
                </v-list-item-content>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }}</v-list-item-title><br>
                  <small class="text-neutral">{{ data.item.description }}</small>
                </v-list-item-content>
              </template>
            </v-select>
            <small
              v-if="error && !selectedCurrency"
              class="text-danger"
            ><b>{{ $t("gateway.choosePaymentCurrency") }}</b></small>
          </v-flex>

          <v-flex
            xs12
            mt-2
            ml-5
            mb-2
          >
            <center>
              <v-btn
                class="primary mt-5 mb-8"
                block
                :loading="loading"
                :disabled="loading"
                @click="pay()"
              >
                {{ $t('gateway.pay') }} {{ invoice.currency | renderSymbol }}{{ invoice.tag === 'deposit_funds' ? invoice.total : invoiceDiff }}
              </v-btn>
            </center>
          </v-flex>
        </v-layout>
      </div>
      <div
        v-else
        class="mt-5 mb-5"
      >
        <center>
          {{ $t('gateway.notAvaliable') }}
        </center>
      </div>
    </v-flex>
    <coinpayments
      v-if="gateway === 'cpay'"
      :invoice="invoiceCopy"
      :currency="selectedCurrencyObj.name"
      :protocol="selectedCurrencyObj.description"
      :currency-id="selectedCurrency"
      @backToStep2="removeTransactionHandler"
    />
  </v-layout>
</template>

<script>
const INVOICE_QUERY = require("@/graphql/queries/Invoice.gql");
import Coinpayments from "@/views/Gateways/partial/Gateway.vue";

import { mapGetters, mapMutations } from "vuex";
import USER_BALANCE_QUERY  from "@/graphql/queries/UserBalance.gql";
import PAY_FROM_BALANCE from "@/graphql/mutations/PayFromBalance.gql";
import CPAY_CONFIG_QUERY from "@/graphql/queries/CpayConfig.gql";
export default {
  name: "ChooseGateway",
  components: {
    Coinpayments,
  },
  props: {
    invoiceId: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      selectedCurrency: null,
      invoiceCopy: null,
      error: false,
      selectedGateway: 'cpay',
      gateway: null,
      loading: false
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    balance() {
      return this.userBalance.wallet.find(o => o.currency == this.invoice.currency);
    },
    selectedCurrencyObj() {
      return this.cpayConfig.find(({id})=>id === this.selectedCurrency)
    },
    enoughBalanceFunds() {
      return this.balance.credit - this.invoice.total >= 0
    },
    invoiceDiff() {
      let diff = this.invoice.total - this.balance.credit
      return diff.toFixed(2);
    },
  },
  beforeDestroy() {
    this.$apollo.queries.invoice.stopPolling();
  },
  methods: {
    ...mapMutations({
      setPaymentsStep: 'app/setPaymentStep',
      updateUser: 'user/updateUser',
      setPending: 'invoice/setPending'
    }),
    removeTransactionHandler() {
      this.setPaymentsStep(2);
      this.gateway = null;
    },
    pay() {
      if (!this.selectedGateway || (this.selectedGateway == 'cpay' && !this.selectedCurrency)) {
        this.error = true
        return
      }
      this.invoiceCopy = JSON.parse(JSON.stringify(this.invoice))
      this.invoiceCopy.total -= this.balance.credit
      this.gateway = this.selectedGateway;
    },
    payFromBalance() {
      this.loading = true
      this.$apollo.mutate({
          mutation: PAY_FROM_BALANCE,
          variables: {
            invoice_id: this.invoice.id,
          }
      }).then(() => {
          this.$router.push("/thankyou/" + this.invoice.tag);
      }).catch(error => {
          this.loading = false;
          if (error.graphQLErrors[0].extensions.category == 'authorization' && error.graphQLErrors[0].message === "This action is unauthorized.") {
            this.$store.commit("app/setShowPermission");
            return;
          }
          this.errorHandler(error)
      })
    },
    onInvoicePaid() {
      this.$emit('closeDialog')
    }
  },
  apollo: {
    cpayConfig: {
      query: CPAY_CONFIG_QUERY,
    },
    userBalance: {
      query: USER_BALANCE_QUERY,
      fetchPolicy: "network-only"
    },
    invoice: {
      query: INVOICE_QUERY,
      pollInterval: 20 * 1000,
      variables() {
        return {
          id: this.invoiceId || this.$route.params.id
        };
      },
      result(data) {
        if (!data.loading) {
          if (data.data.invoice.status == "paid") {
            this.updateUser();
            this.setPending(null)
            this.$emit("closeDialog");
            this.$router.push("/thankyou/" + data.data.invoice.tag);
          }
        }
      }
    }
  }
};
</script>
<style lang="scss">
.gateway-card {
  h4 {
    small {
      margin-top:10px;
      display: block;
      font-weight:500;
      font-size:14px;
      line-height: 18px;
    }
  }
  .v-card {
    padding: 15px !important;
    margin: 10px;
    .crypto {
      display: table;
      .v-image {
        margin-left: 5px;
        margin-right: 5px;
        display: inline-block;
      }
    }
  }
  .method {
    &.active {
      border: 1px solid var(--color-secondary-text-opacity-20);
    }
  }
  h4 {
    font-weight: 600 !important;
  }
  center {
    margin-top: 10px;
  }
  .v-card__title {
    margin-bottom: 30px !important;
  }
  p {
    margin: 0;
  }
  .centered-input {
    input {
      text-align: center !important;
    }
  }
  .v-image {
    margin: 15px 0 10px;
  }
}
</style>
